import { VesselPositionData, PositionData } from '../services/types/position-service.types';
import { BaseModel } from './base-model';

export abstract class VesselPositionModelBase extends BaseModel
{
    abstract get position(): VesselPositionData|null;
    abstract get track(): PositionData[];
    abstract get usingManualPositionOverride(): boolean;
    abstract setManualPositionOverride(override: boolean): Promise<void>
    abstract setManualPosition(coordinates: [number, number], timestamp?: string): Promise<void>
    abstract get malfunctioningGPS(): boolean;
}

let VesselPositionModel: VesselPositionModelBase|null = null;

function setVesselPositionModel(model: VesselPositionModelBase)
{
    VesselPositionModel = model;
}

export { VesselPositionModel, setVesselPositionModel };
